
import axios from "axios";
import GLOBAL from "../Global.js";

export default class ClienteService {


    actualizarInformacionCliente(person, request) {
        if (request.tercero._id == "") {
            var url = GLOBAL.BASE_URL + GLOBAL.API_POST_CREAR_CLIENTES
            console.log(url)
            return axios.post(url, request, {
                headers: {
                    timeout: 15000,
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
                .catch((error) => console.log(error));
        } else {
            var url = GLOBAL.API_PUT_EDITAR_CLIENTES;
            console.log(url)
            return axios.put(url, request, {
                timeout: 15000,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
                .catch((error) => console.log(error));
        }
    }

    getReporteClientes(person) {
        var url1 = GLOBAL.API_GET_REPORTE_CLIENTES;
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }


    getListaTipoDocumento(person) {
        let url = GLOBAL.BASE_URL + GLOBAL.API_GET_LISTA_DOCUMENTOS;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaTipoDocumentoMexico(person) {
        var url1 = GLOBAL.API_GET_LISTA_CATALOGO_MEXICO;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaPaises(person) {

        let url = GLOBAL.BASE_URL + GLOBAL.API_GET_LISTA_PAIS;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaProvinciasFull(person, pais) {
        let url = GLOBAL.BASE_URL + GLOBAL.API_GET_LISTA_DEPARTAMENTOS_FULL + "/" + btoa(pais);
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaProvincias(person, pais) {
        var url = GLOBAL.API_GET_LISTA_DEPARTAMENTOS
        var autho = "Basic " + GLOBAL.BASIC_API;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: autho
                },
            }).then((response) => {
                let json = response;
                var valores = []
                for (const key in json.data) {
                    valores[0] = []
                    valores[0].id = 0
                    valores[0].text = "Seleccione"
                    valores[0].disabled = true
                    var y = 1
                    for (const skey in json.data[key]) {
                        var ciu = (json.data[key][skey])
                        valores[y] = []
                        valores[y].id = y
                        valores[y].text = ciu
                        y++
                    }
                }
                return valores;
            }).catch((error) => console.log(error));
    }


    getListaCiudadesFull(person, pais, provincia) {
        var url = GLOBAL.BASE_URL + GLOBAL.API_GET_LISTA_CIUDADES_FULL + "/" + btoa(provincia + ":" + pais);
        console.log(url)
        var autho = "Basic " + GLOBAL.BASIC_API;

        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic MTNHQVM6OTk5OQ==",
                    Environment: person.empresas
                },
            }).then((response) => {
                let json = response.data.parametro.ciudades;
                console.log(json)
                var ciudades = [];
                var j = 0;
                for (var i in json) {
                    ciudades.push({ id: json[i]._id, text: json[i].name })
                    j++
                }
                return ciudades;
            }).catch((error) => console.log(error));
    }

    getListaCiudades(person, pais, provincia) {

        var url = GLOBAL.API_GET_LISTA_CIUDADES
        var autho = "Basic " + GLOBAL.BASIC_API;

        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: autho
                },
            }).then((response) => {

                let json = response;
                var ciudades;
                if (GLOBAL.APIS_PLEMSIS.IS_GET_CIUDADES) {
                    ciudades = []
                    for (const key in json.data) {
                        ciudades[0] = []
                        ciudades[0] = []
                        ciudades[0].id = 0
                        ciudades[0].text = "Seleccione"
                        ciudades[0].disabled = true
                        var y = 1
                        for (const skey in json.data[key]) {
                            var ciu = (json.data[key][skey])
                            ciudades[y] = []
                            ciudades[y].id = y
                            ciudades[y].text = ciu
                            y++
                        }
                    }
                } else {
                    this.ciudades = json.data.parametro.ciudades
                    var j = 0;
                    for (var i in this.ciudades) {
                        ciudades[i].id = j
                        ciudades[i].text = ciudades[i].name
                        j++
                    }
                }

                return ciudades;

            }).catch((error) => console.log(error));
    }

    agregarRecargarCliente(person, request) {
        var url = GLOBAL.API_GET_REPORTE_CLIENTES_RECARGA;
        return axios.post(url, request, {
            timeout: 60000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                Authorization: "Basic " + person.token,
                Environment: person.empresas
            },
        }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getRecargarCliente(person) {
        let url = GLOBAL.API_GET_REPORTE_CLIENTES_RECARGA;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getSaldoCliente(person, cliente, fecha) {
        let url = GLOBAL.API_GET_REPORTE_CLIENTES_SALDO + "/" + cliente + "/" + fecha;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    updateRecarga(person, request) {
        let url = GLOBAL.API_GET_REPORTE_CLIENTES_RECARGA + "/actualizar";
        return axios.put(url, request, {
            timeout: 15000,
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: "Basic " + person.token,
                Environment: person.empresas
            },
        }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getExtractoDeCliente(person, cliente, fecha) {
        let url = GLOBAL.API_GET_REPORTE_CLIENTES_EXTRACTO + "/" + cliente + "/" + fecha;
        return axios
            .get(url.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

}